import React from 'react'

import * as S from './styles'

function SatisfactionSurveyModal ({ show, loading, onHandleRate, onHandleClose, petType }) {
  return (
    <S.Container show={show}>
      <S.Backdrop onClick={onHandleClose} />
      <S.ModalContent>
        <S.ModalBody>
          <S.Img petType={petType} />
          <S.Title>Lembra do seu último <br />atendimento com a gente?</S.Title>

          <S.Paragraph>Avalie o serviço realizado e nos ajude a continuar oferecendo o melhor para você e seu pet</S.Paragraph>

          <S.Actions>
            <S.Button disabled={loading} onClick={onHandleClose} outline>Agora não</S.Button>
            <S.Button disabled={loading} onClick={onHandleRate} lastButton>Avaliar</S.Button>
          </S.Actions>
        </S.ModalBody>
      </S.ModalContent>
    </S.Container>
  )
}

export default SatisfactionSurveyModal
